var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"separate-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.intro)?_c('p',{staticClass:"separate-intro"},[_vm._v(_vm._s(_vm.intro))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }